(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-geolocation.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-geolocation.js');
"use strict";

const {
  useSetAtom
} = jotai;
const {
  pinLocationAtom,
  pinLocationTypeAtom,
  mapLocationAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  showPremissionDenied,
  showWebBrowserNotSupport,
  showWPositionUnavailableOrTimeout,
  notAccuracyLocationDialog
} = svs.lyckoplatsen.components.page_play.utils;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const useGeolocation = () => {
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setMapLocation = useSetAtom(mapLocationAtom);
  const handler = () => {
    const onSuccess = position => {
      svs.ui.loader.hide();
      setPinLocationType(CONSTANTS.LOCATION_TYPES.CURRENT);
      if (position.coords.accuracy >= CONSTANTS.GEO_ACCURACY_THRESHOLD) {
        notAccuracyLocationDialog();
        setMapLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      } else {
        setPinLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      }
    };
    const onError = error => {
      svs.ui.loader.hide();
      if (error.code === error.PERMISSION_DENIED) {
        showPremissionDenied();
      } else if (error.code === error.POSITION_UNAVAILABLE || error.code === error.TIMEOUT) {
        showWPositionUnavailableOrTimeout();
      }
    };
    if (navigator.geolocation) {
      svs.ui.loader.show();
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 30000
      });
    } else {
      showWebBrowserNotSupport();
    }
  };
  return handler;
};
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useGeolocation
});

 })(window);